import { Router } from '@angular/router';
import { WizardViewModel } from './../wizard-view-model';
import { DentallyWizardService } from './../dentally-wizard.service';
import { Component, OnInit } from '@angular/core';
import { IHasStepNumber } from 'src/core/interfaces/IHasStepNumber';
import { MatDialog } from '@angular/material';
import { DentallyTreatmentsDialog } from './dialogs/dentally-treatments.dialog';
import { CommunicationPreviewDialog } from './dialogs/communication-preview.dialog';
import { VisitTypeAssignment } from '../VisitTypeAssignment';

export type VisitTypeInfo = { treatments: { code: string, name: string, selected?: boolean }[], id?: string };
export type VisitTypeGroupped = { [name: string]: VisitTypeInfo };

@Component({
  selector: 'app-dentally-preview',
  templateUrl: './dentally-preview.component.html',
  styleUrls: ['./dentally-preview.component.scss']
})
export class DentallyPreviewComponent implements OnInit, IHasStepNumber {

  constructor(private dentallyService: DentallyWizardService, private dialog: MatDialog, private router: Router) { }
  stepNumber: number = 2;
  selectedVisitType = '';
  wizardState: WizardViewModel;
  visitTypes = {} as VisitTypeGroupped;


  ngOnInit() {
    this.dentallyService.getWizardState()
      .subscribe((s) => {
        this.wizardState = s;
        this.initComponentState(s);
      });

  }

  initComponentState(state: WizardViewModel): any {
    this.visitTypes = this.dentallyService.groupVisitTypes(state.data.visitTypeAssignments, state.data.treatments);
  }

  onConfirmAllClick(event) {
    const transformedVisitTypes = new Array<VisitTypeAssignment>();
    for (const visitType in this.visitTypes) {
      const treatments = this.visitTypes[visitType].treatments;
      transformedVisitTypes.push({
        visitTypeName: visitType,
        itemCodes: treatments.map(t => t.code)
      });
    }
    this.wizardState.data.visitTypeAssignments = transformedVisitTypes;
    this.dentallyService.updateWizardStep(this.wizardState)
      .subscribe((s) => {
        this.router.navigateByUrl("/wizard/dentally/communications");
      });
  }

  onVisitTypeClick(visitType: string) {
    this.selectedVisitType = visitType;
  }

  onViewEditTreatmentMapClick(event) {
    const dialogRef = this.dialog.open(DentallyTreatmentsDialog, {
      width: '400px',
      data: {
        treatments: this.visitTypes[this.selectedVisitType].treatments,
        visitTypesDropDown: Array.from(new Set(this.wizardState.data.visitTypeAssignments.map(v => v.visitTypeName)))
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateAssignments(result.moveTo, result.itemCodes);
      }
    });
  }
  updateAssignments(moveTo: string, itemCodes: string[]): any {
    let visitTypeInfo: VisitTypeInfo = this.visitTypes[this.selectedVisitType];
    const toMove = visitTypeInfo.treatments.filter(c => itemCodes.includes(c.code));
    toMove.forEach(t => t.selected = false);
    const currentTreatments = visitTypeInfo.treatments.filter(c => !itemCodes.includes(c.code));
    const targetTreatments = this.visitTypes[moveTo].treatments;
    const updatedTreatments = targetTreatments.concat(toMove);
    this.visitTypes[this.selectedVisitType].treatments = currentTreatments;
    this.visitTypes[moveTo].treatments = updatedTreatments.sort(c => c.code as any);
  }

  onViewEditCommunicationsClick(event) {
    const dialogRef = this.dialog.open(CommunicationPreviewDialog, {
      width: '800px',
      data: { selectedVisitTypeId: this.visitTypes[this.selectedVisitType].id }
    });
  }
}
